import React from 'react';
import { Link } from 'gatsby';

const ResultBaseInfo = ({ caseStudy }) => {
  return (
    <div className="container container-full">
      <div className="awarded-block">
        <div className="awarded-container">
          <div className="item">
            <div className="tt">Industry</div>
            <div className="dd">{caseStudy.frontmatter.info.industry}</div>
          </div>
          <div className="item">
            <div className="tt">Technology</div>
            <div className="dd">
              {caseStudy.frontmatter.technologies.oneline}
            </div>
          </div>
          {caseStudy.frontmatter.info.responsibilities && (
            <div className="item">
              <div className="tt">Responsibilities</div>
              <div className="dd">
                {caseStudy.frontmatter.info.responsibilities}
              </div>
            </div>
          )}
          {caseStudy.frontmatter.info.projectDuration && (
            <div className="item">
              <div className="tt">Project duration</div>
              <div className="dd">
                {caseStudy.frontmatter.info.projectDuration}
              </div>
            </div>
          )}
          {caseStudy.frontmatter.info.link && (
            <div className="item">
              <div className="tt">Link</div>
              <div className="dd">
                <a
                  className="external-link"
                  href={caseStudy.frontmatter.info.link.url}
                >
                  {caseStudy.frontmatter.info.link.text}
                </a>
              </div>
            </div>
          )}
          {caseStudy.frontmatter.info.scope && (
            <div className="item">
              <div className="tt">Project scope</div>
              <div className="dd">{caseStudy.frontmatter.info.scope}</div>
            </div>
          )}
          {caseStudy.frontmatter.info.companySize && (
            <div className="item">
              <div className="tt">Company size</div>
              <div className="dd">{caseStudy.frontmatter.info.companySize}</div>
            </div>
          )}
          {caseStudy.frontmatter.info.country && (
            <div className="item">
              <div className="tt">Country of origin</div>
              <div className="dd">{caseStudy.frontmatter.info.country}</div>
            </div>
          )}
          {caseStudy.frontmatter.info.oneline && (
            <div className="item auto">
              <div className="tt">Project summary</div>
              <div className="dd">{caseStudy.frontmatter.info.oneline}</div>
            </div>
          )}
          {caseStudy.frontmatter.info.interested && (
            <div className="item">
              <div className="tt">Interested?</div>
              <div className="dd text-danger">
                <Link
                  className="external-link text-danger"
                  to='/contact'
                >
                  {caseStudy.frontmatter.info.interested}</Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResultBaseInfo;
